var _rect, _rect2, _g, _rect3, _g2, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchNoResults = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 200,
  height: 151,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 77.288,
  height: 96.526,
  fill: "#EAE3DA",
  rx: 12,
  transform: "matrix(.9651 -.2619 .25578 .96674 0 55.68)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 77.288,
  height: 96.526,
  fill: "#EAE3DA",
  rx: 12,
  transform: "matrix(.96504 .2621 -.25557 .96679 125.414 35.422)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#search-no-results_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 88.076,
  height: 110.065,
  x: 56.265,
  y: 17,
  fill: "#fff",
  rx: 12
}))), /*#__PURE__*/React.createElement("mask", {
  id: "search-no-results_svg__b",
  width: 89,
  height: 111,
  x: 56,
  y: 17,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 88.076,
  height: 110.065,
  x: 56.265,
  y: 17,
  fill: "#fff",
  rx: 12
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#search-no-results_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFDB00",
  d: "M175.694 22.828a.3.3 0 0 0-.048-.035C174.79 22.2 154.527 8.22 143.913 6.36c-3.272-.573-5.445.104-6.462 2.007-1.786 3.34 1.303 7.592 8.459 15.294.663.715 1.235 1.33 1.597 1.746.259.3.593.68.99 1.128 2.908 3.312 10.769 12.258 14.574 18.822-5.267-2.689-14.544-8.632-21.227-12.912-6.601-4.227-13.427-8.601-18.606-11.516-5.643-3.173-34.33-18.85-45.121-15.758l-.086.025c-1.567.505-2.654 1.643-2.983 3.12-.887 3.982 3.81 8.933 13.981 18.523 2.107 1.987 4.096 3.862 5.556 5.37 6.356 6.567 14.576 16.235 12.56 24.37-.211.846-.641 1.389-1.439 1.81-6.44 3.388-27.097-4.552-33.886-7.163-12.26-4.713-25.524-12.64-37.225-19.632l-2.48-1.48a3 3 0 0 0-.313-.158 2.7 2.7 0 0 0-1.168-.268c-1.504 0-2.722 1.229-2.722 2.747 0 1.044.577 1.951 1.426 2.417l2.474 1.478c11.89 7.106 25.366 15.16 38.064 20.041 14.65 5.631 24.666 8.323 31.424 8.323 2.856 0 5.131-.482 6.925-1.427 2.167-1.14 3.621-2.993 4.206-5.352 1.231-4.973.036-10.56-3.558-16.605-3.057-5.142-7.394-9.85-10.39-12.945-1.548-1.597-3.582-3.515-5.734-5.545-3.423-3.226-10.102-9.524-11.91-12.553 6.422-.425 22.553 5.807 39.737 15.475 5.043 2.838 11.804 7.17 18.339 11.356 21.642 13.862 27.012 16.855 30.06 14.417.583-.466 1.841-1.822.967-4.364-2.247-6.535-10.465-16.399-17.372-24.26-.386-.439-.713-.811-.964-1.103-.422-.486-1.025-1.135-1.721-1.885-1.426-1.536-5.183-5.583-6.763-8.09 9.504 1.767 29.231 15.381 29.432 15.52q.13.088.262.16c.404.24.874.38 1.378.38 1.505 0 2.723-1.229 2.723-2.747a2.74 2.74 0 0 0-1.223-2.299"
}))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 52.484,
  height: 4.892,
  x: 69.535,
  y: 76.924,
  fill: "#EAE3DA",
  rx: 2.446
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 32.051,
  height: 4.892,
  x: 69.535,
  y: 84.874,
  fill: "#EAE3DA",
  rx: 2.446
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 60.326,
  height: 4.892,
  x: 69.535,
  y: 100.16,
  fill: "#EAE3DA",
  rx: 2.446
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 43.59,
  height: 4.892,
  x: 69.535,
  y: 108.109,
  fill: "#EAE3DA",
  rx: 2.446
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "search-no-results_svg__a",
  width: 128.076,
  height: 150.065,
  x: 36.265,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_34119_48596"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_34119_48596",
  result: "shape"
})))));
export default SvgSearchNoResults;